import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BottomNav } from "./BottomNav";
import { SplashScreen } from "./SplashScreen";
import { mainRoutes } from "../lib/navigation";

export interface AppShellProps {
  readonly children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const location = useLocation();
  const showNav = mainRoutes.has(location.pathname);
  const [showSplash, setShowSplash] = useState(false);
  const [contentEntering, setContentEntering] = useState(false);

  useEffect(() => {
    // Disabled splash screen per user request
    setShowSplash(false);
  }, []);

  const handleSplashComplete = () => {
    setShowSplash(false);
    // Smooth content entrance after splash exits
    setContentEntering(true);
    setTimeout(() => setContentEntering(false), 450);
  };

  return (
    <div className="app-shell">
      <div className={`phone-frame ${contentEntering ? "content-entering" : ""}`}>
        {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
        {children}
      </div>
      {showNav && <BottomNav />}
    </div>
  );
}
